module.exports = "\n<div class=\"vue-codemirror-wrap\">\n  <textarea></textarea>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-codemirror-lite/codemirror.vue
// module id = 2318
// module chunks = 38